<template>
	<modal
		@cancel="$emit('cancel')"
		:loading="loading"
		loading-message="Subscribing..."
		class="sign-up-success"
	>
		<template #close-button>
			<icon name="remove" label="Close" />
		</template>
		<div class="sign-up-success__wrapper">
			<h2 class="sign-up-success__header">
				Thank you!
			</h2>
			<p class="sign-up-success__subtext">
				You're on our mailing list to hear about deals, special events, new arrivals, weekly sales flyers and more!
			</p>
			<p class="sign-up-success__secondary-text">
				Please add enews@farmandfleet.com to your safe senders list.
			</p>
			<b-button
				@click="$emit('cancel')"
				v-focus
				aria-label="You’re all set to know about new arrivals, special events and new sales flyers, plus more more! Continue Shopping."
				class="sign-up-success__button"
			>
				Continue Shopping
			</b-button>
		</div>
	</modal>
</template>

<script>
import BButton from 'JS/components/BButton.vue';
import focus from '../../../directives/focus';
import Icon from 'JS/components/Icon.vue';
import Modal from '../../../components/Modal.vue';
export default {
	name: 'SignUpModalSuccess',
	props: {
		loading: Boolean
	},
	components: {
		BButton,
		Icon,
		Modal,
	},
	directives: {
		'focus': focus
	},
};
</script>

<style lang="less" scoped>
@import '../../../../less/_mixins.less';
.blain-modal-loading {
	padding: 42px 20px 45px 20px;
	.mobile-styles({
		padding: 35px 20px 35px 20px;
	});
}

.sign-up-success {

	/deep/ .blain-modal-content {
		border: 0;
		border-radius: 8px;
		padding: 0 !important;
		max-width: 100%;

		.tablet-and-up-styles({
			width: 520px;
		});

		button.close-btn {
			position: absolute;
			right: 20px;
			top: 24px;
			color: @BB;
			font-size: 24px;
			background-color: transparent;
			border: none;
			z-index: 1;

			.mobile-and-up-styles({
				right: 30px;
				top: 30px;
			});
		}
	}

	&__wrapper {
		padding: 30px;
	}

	&__header {
		font-size: 1.5rem;
		line-height: 1;
		font-weight: bold;
		margin-bottom: 30px;
	}

	&__subtext {
		font-size: 1.125rem;
		line-height: 1.25;
		font-weight: bold;
		margin-bottom: 15px;
	}

	&__secondary-text {
		font-size: 1rem;
		line-height: 1.25;
		margin-bottom: 27px;
	}

	&__button {
		width: 100%;
	}
}
</style>